import Vue from "vue";
import Layout from "./components/layout/Layout.vue";
import router from "./router";
import store from "./store";
import Alert from "./components/Shared/Alert.vue";
import * as firebase from "firebase";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
Vue.component("app-alert", Alert);

firebase.initializeApp({
  apiKey: "AIzaSyBkxUfdVRjVHkeyqMpL0dBm_D0qx9Pfuq4",
  authDomain: "platforma-81f70.firebaseapp.com",
  databaseURL: "https://platforma-81f70.firebaseio.com",
  projectId: "platforma-81f70",
  storageBucket: "platforma-81f70.appspot.com",
  messagingSenderId: "358705966509",
  appId: "1:358705966509:web:405edc90dfd52da73b8524",
  measurementId: "G-FR73ZCSQ33"
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Layout),
  created() {
    // this.$vuetify.theme.dark = true;
  }
}).$mount("#app");
